import { render } from "./ModalUploadIcon.vue?vue&type=template&id=0010555e&scoped=true"
import script from "./ModalUploadIcon.vue?vue&type=script&lang=js"
export * from "./ModalUploadIcon.vue?vue&type=script&lang=js"

import "./ModalUploadIcon.vue?vue&type=style&index=0&id=0010555e&lang=scss&scoped=true"
import "./ModalUploadIcon.vue?vue&type=style&index=1&id=0010555e&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0010555e"]])

export default __exports__